// BM-H398 - s11_letter_of_wishes. `opted_in` drives C-23 (Structure C opts
// in regardless). Long reasoning about beneficiaries is flagged by the engine
// for supervisor review; we do not pre-empt that here.

import { QuestionRow, SectionIntro, TextArea, YesNo, sectionProps } from "./fields";
import { STRUCTURES } from "./willsPayload";

export default function S11LetterOfWishes({ section, setSection, answers }) {
  const { s, set, nk, setNk } = sectionProps(section, setSection);
  const wishes = s.captured_wishes || {};
  const structureC = (answers || {}).s5_structure?.chosen_structure === STRUCTURES.C;
  return (
    <div data-testid="section-s11_letter_of_wishes">
      <SectionIntro title="Letter of wishes">
        A separate, non binding letter that guides your executors and trustees. {structureC ? "Because your estate passes on a discretionary trust, we will prepare one with you." : "Most people leave it blank; some fill it with a story. Both are fine."}
      </SectionIntro>
      <QuestionRow qid="s11_letter_of_wishes.opted_in" label="Would you like a letter of wishes alongside your will?" notKnown={nk("opted_in")} onNotKnown={(on) => setNk("opted_in", on)}>
        <YesNo testid="s11-opted-in" value={s.opted_in} disabled={nk("opted_in")} onChange={(v) => set({ opted_in: v })} />
      </QuestionRow>
      {(s.opted_in === true || structureC) && (
        <>
          <QuestionRow qid="s11_letter_of_wishes.captured_wishes.priority_context" label="Anything you want your executors to know or do">
            <TextArea testid="s11-priority-context" value={wishes.priority_context} onChange={(v) => set({ captured_wishes: { ...wishes, priority_context: v } })} />
          </QuestionRow>
          <QuestionRow qid="s11_letter_of_wishes.captured_wishes.why_this_structure" label="Why you have arranged things this way">
            <TextArea testid="s11-why-structure" value={wishes.why_this_structure} onChange={(v) => set({ captured_wishes: { ...wishes, why_this_structure: v } })} />
          </QuestionRow>
        </>
      )}
    </div>
  );
}
